import { render } from "./SousPand.vue?vue&type=template&id=21288e63&scoped=true"
import script from "./SousPand.vue?vue&type=script&lang=js"
export * from "./SousPand.vue?vue&type=script&lang=js"

import "./SousPand.vue?vue&type=style&index=0&id=21288e63&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\benja\\Desktop\\SKWinkelStarter\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21288e63"]])

export default __exports__